import httpService from '@/modules/common/services/httpService';
import callsTextingService from '@/modules/callsTexting/services/callsTextingService';

const fetchSettingsPageData = () => httpService.get('/v2/settings/settings_page_data').then((res) => res.data);

const fetchVoiceCallSettings = () => callsTextingService.getCallsSettings()
  .then((body) => body?.data?.voice_call_settings?.[0]);

export default {
  fetchSettingsPageData,
  fetchVoiceCallSettings,
};
